/**
 * Copyright © OXID eSales AG. All rights reserved.
 * See LICENSE file for license details.
 */

import '../../../styles/backend/vanilla-picker.scss'
import Picker from 'vanilla-picker';

export class VisualEditor {

    constructor(shortcodes, options) {
        'use strict';
        this.log( 'Visual Editor Version: ' + VisualEditor.VERSION );

        if ( typeof shortcodes === 'undefined' )
        {
            throw new Error( 'no shortcodes given' );
        }

        this.log( 'Initializing Visual Editor' );
        this.log( options );

        // Class properties
        this.shortcodes = shortcodes;
        this.options    = $.extend( {}, VisualEditor.DEFAULTS, typeof options === 'object' && options );
        this.$container = typeof this.options.container === 'string' ? $( this.options.container ) : this.options.container;
        this.$grid      = $( '.grid', this.$container );
        this.$modal     = typeof this.options.modal === 'string' ? $( this.options.modal ) : this.options.modal;

        if ( this.options.defaultWidgetSize > this.options.gridSize )
        {
            this.options.defaultWidgetSize = this.options.gridSize;
        }

        // Calculating column size
        this.options.colSize   = Math.floor( this.$container.width() / this.options.gridSize ) - 12;
        this.options.colWidth  = this.options.colSize;
        this.options.colHeight = this.options.colSize;

        if ( this.options.colSize < 140 )
        {
            this.options.colHeight = 140;
        }
        else
        {
            if ( this.options.colSize > 220 )
            {
                this.options.colHeight = 220;
            }
        }

        this.init();
    };


    // VISUAL EDITOR MAIN PROPERTIES
    // =============================

    static VERSION  = '2.0.0';

    static DEFAULTS = {
        gridSize: 6,
        gridFrontendSize: 12,
        defaultWidgetSize: 1,
        container: '.dd-veditor',
        modal: '.dd-widget-modal',
        actionLink: null,
        resourceLink: null
    };

    static WIDGET_DEFAULTS = {
        col: null,
        row: null,
        size_x: 1,
        size_y: 1
    };

    static DEBUG = false;


    // VISUAL EDITOR METHODS
    // =====================

    // Debugging Methods
    // -----------------

    timestamp()
    {
        var ts = new Date();

        return ts.getFullYear() + '-' +
            ( (ts.getMonth() + 1) < 10 ? '0' : '' ) + (ts.getMonth() + 1) + '-' +
            ( ts.getDate() < 10 ? '0' : '' ) + ts.getDate() + ' ' +
            ( ts.getHours() < 10 ? '0' : '' ) + ts.getHours() + ':' +
            ( ts.getMinutes() < 10 ? '0' : '' ) + ts.getMinutes() + ':' +
            ( ts.getSeconds() < 10 ? '0' : '' ) + ts.getSeconds();
    };

    log( msg, type, trace )
    {
        if ( VisualEditor.DEBUG )
        {
            if ( typeof type === 'undefined' )
            {
                type = 'log';
            }
            if ( typeof trace === 'undefined' )
            {
                trace = false;
            }

            if ( typeof console !== 'undefined' )
            {
                if ( typeof console[ type ] !== 'undefined' )
                {
                    console[ type ]( '[Visual Editor][' + this.timestamp() + '] ', msg );
                }

                if ( trace )
                {
                    console.trace();
                }
            }
        }
    };

    isDebugMode()
    {
        return VisualEditor.DEBUG;
    };


    // Init Methods
    // ------------

    async init() {
        if (!window.mediaLibraryUrl) {
            console.error("Media Library URL not found");
            return;
        }

        try {
            const module = await import(window.mediaLibraryUrl);
            this.ddh = module.ddh;
            this.MediaLibrary = module.MediaLibrary
            // Register areaselect as a jQuery plugin
            if (module.areaselect) {
                module.areaselect();
            }

            // Initialize grid
            this.initializeGrid();

            // Sets widget select events
            this.setWidgetSelector();

            // Initialize 3rd Party plugins
            this.initializePlugins();
        } catch (error) {
            console.error("Failed to load Media Library module:", error);
        }

        document.dispatchEvent(new Event("ve:ready"));
    }

    initializeGrid()
    {
        this.log( 'Initializing Grid' );
        this.log( this.options );

        // Set grid min height
        this.$grid.css( 'min-height', this.options.colHeight );

        // Initialize gridstack plugin
        this.gridstack = GridStack.init(
            {
                verticalMargin: 10,
                cellHeight: this.options.colHeight,
                column: this.options.gridSize,
                acceptWidgets: false,
                resizable: {
                    autoHide: true,
                    handles: 's, e'
                }
            },
            this.$grid
        );

        this.log( 'Setting Widget events' );

        // Set Widget events
        var self = this;

        // Delete Widget
        this.$grid.on( 'click', '.dd-veditor-widget .dd-widget-action-delete', function ()
            {
                var $widget     = $( this ).closest( '.dd-veditor-widget' );
                var $nestedGrid = $widget.closest( '.nested-grid' );

                if ( $nestedGrid.length )
                {
                    self.nestedgridstack = $nestedGrid.get( 0 ).gridstack;
                }

                self.ddh.confirm( self.ddh.translate( ( $widget.hasClass( 'dd-veditor-column' ) ? 'DD_VISUAL_EDITOR_WIDGET_DELETE_NESTED_CONFIRM' : 'DD_VISUAL_EDITOR_WIDGET_DELETE_CONFIRM' ) ), function ()
                    {
                        self.remove( $widget, function ()
                            {
                                self.nestedgridstack = null;
                            }
                        );
                    }
                );
            }

            // Edit Widget
        ).on( 'click', '.dd-veditor-widget .dd-widget-action-edit', function ()
            {
                var $widget     = $( this ).closest( '.dd-veditor-widget' );
                var $nestedGrid = $widget.closest( '.nested-grid' );

                if ( $nestedGrid.length )
                {
                    self.nestedgridstack = $nestedGrid.get( 0 ).gridstack;
                }
                else
                {
                    self.nestedgridstack = null;
                }

                var $typeSelect = $( '.dd-widget-type-select', self.$modal );

                if ( $widget.hasClass( 'dd-veditor-column' ) )
                {
                    $typeSelect[ 0 ].selectize.addOption( { value: 'column', label: "", area: "dd-type-column" } );
                    $typeSelect[ 0 ].selectize.refreshOptions( false );
                    $typeSelect.parent().parent().hide();
                    //$( 'a[href="#tab_widget_design"]', self.$modal ).tab( 'show' );
                }
                else
                {
                    $typeSelect[ 0 ].selectize.removeOption( 'column' );
                    $typeSelect.parent().parent().show();
                }

                self.editWidget( $widget, function ()
                    {
                        self.nestedgridstack = null;
                    }
                );
            }

            // New Nested Widget
        ).on( 'click', '.dd-veditor-widget .dd-widget-action-new-nested', function ()
            {
                var $widget     = $( this ).closest( '.dd-veditor-widget' );
                var $nestedGrid = $widget.find( '.nested-grid' );

                self.nestedgridstack = $nestedGrid.get( 0 ).gridstack;

                if ( !self.nestedgridstack.willItFit( 1, 1, 1, 1, true ) )
                {
                    self.ddh.alert( self.ddh.translate( 'DD_VISUAL_EDITOR_NO_SPACE_WARNING' ) );
                }
                else
                {
                    self.newWidget( function ()
                        {
                            self.nestedgridstack = null;
                        }
                    );
                }

            }
        ).on( 'click', '.dd-veditor-widget .dd-widget-action-duplicate', function ()
            {
                var $widget     = $( this ).closest( '.dd-veditor-widget' );
                var $nestedGrid = $widget.closest( '.nested-grid' );

                if ( $nestedGrid.length )
                {
                    self.nestedgridstack = $nestedGrid.get( 0 ).gridstack;
                }
                else
                {
                    self.nestedgridstack = null;
                }

                self.duplicateWidget( $widget, function ()
                    {
                        self.nestedgridstack = null;
                    }
                );
            }
        ).on( 'click', '.dd-veditor-widget .dd-widget-action-move', function ()
           {
               var $widget     = $( this ).closest( '.dd-veditor-widget' );
               var $nestedGrid = $widget.closest( '.nested-grid' );

               if( $widget.length )
               {
                   //check if move mode is already active for source widget
                   if( $widget.hasClass( 'move-source' ) )
                   {
                       // remove move mode
                       self.deactivateMoveMode();
                   }
                   else
                   {
                       // deactivate move mode first if it is already active for another widget
                       if( $('.move-source').length )
                       {
                           self.deactivateMoveMode();
                       }

                       self.log( 'Moving mode on' );

                       $widget.addClass( 'move-source' );
                       self.widgetToMove = $widget;

                       $( '.dd-widget-action-movetarget' ).removeClass( 'in-source-grid' );
                       $( '.dd-veditor-grid' ).addClass( 'move-mode' );

                       if( $nestedGrid.length )
                       {
                           $( $nestedGrid ).prev( '.dd-widget-action-movetarget' ).addClass( 'in-source-grid' );
                           self.addMoveTargetWidget();
                       }
                   }
               }
           }
        );

        this.gridstack.on( 'gsresizestop', function ( e )
            {
                var $widget = $( e.target );

                // Refresh nested grid cell height
                if ( $widget.hasClass( 'dd-veditor-column' ) )
                {
                    var node        = $widget.data( '_gridstack_node' );
                    var $nestedGrid = $widget.find( '.nested-grid' );

                    var _cellHeight = Math.floor( ((self.options.colHeight * node.height) - 85) / node.height );

                    $nestedGrid.get( 0 ).gridstack.cellHeight( _cellHeight );
                }
            }
        );

        // New Widget
        $( '.dd-veditor-widget-action', this.$container ).on( 'click', function ()
            {
                var $typeSelect = $( '.dd-widget-type-select', self.$modal );
                $typeSelect[ 0 ].selectize.removeOption( 'column' );
                $typeSelect.parent().parent().show();

                if( !$( this ).hasClass( 'disabled' ) )
                {
                    self.newWidget();
                }
            }
        );

        // New Column
        $( '.dd-veditor-column-action', this.$container ).on( 'click', function ()
            {
                if( !$( this ).hasClass( 'disabled' ) )
                {
                    self.add( 'column' );
                }
            }
        );

        // Clear Widgets
        $( '.dd-veditor-delete-all-action', this.$container ).on( 'click', function ()
            {
                if( !$( this ).hasClass( 'disabled' ) )
                {
                    self.ddh.confirm( self.ddh.translate( 'DD_VISUAL_EDITOR_WIDGET_DELETE_ALL_CONFIRM' ), function () { self.clear(); } );
                }
            }
        );

        $( document ).on( 'click', '.dd-widget-action-movetarget, .move-target-widget', function ()
            {
                if( typeof self.widgetToMove != 'undefined' && self.widgetToMove != null )
                {
                    if ( $( this ).hasClass( 'move-target-widget' ) )
                    {
                        self.nestedgridstack = null;
                    }
                    else
                    {
                        self.nestedgridstack = $( this ).next( '.nested-grid' ).get( 0 ).gridstack;
                    }

                    var type = self.widgetToMove.data('widget');
                    var params = self.widgetToMove.data( 'widget-params' );

                    self.log( 'Moving Widget "' + type + '"' );

                    var node = self.widgetToMove.data( '_gridstack_node' );

                    var position = {
                        size_x: node.width,
                        size_y: node.height
                    };

                    if( $( '.move-target-widget' ).length ) {
                        self.removeMoveTargetWidget( function ()
                             {
                                 self.move( type, params, position );
                             }
                        );
                    } else {
                        self.move( type, params, position );
                    }

                }
            }
        );

        // New Image Widget
        if ( typeof this.MediaLibrary !== 'undefined' ) {
            var self = this;
            $( '.dd-veditor-media-action', this.$container ).click( function () {
                if( !$( this ).hasClass( 'disabled' ) ) {
                    self.MediaLibrary.open( /image\/.*/i, true, function ( files ) {
                        if ( !files.length ) {
                            return;
                        }

                        $.each( files, function () {
                            self.add( 'image',
                                {
                                    "image": this.file,
                                    "type": "lightbox",
                                    "thumbnail": 1,
                                    "thumbnail_size": "medium",
                                    "width": {
                                        'small-mobile': 12,
                                        'mobile': '',
                                        'laptop': '',
                                        'desktop': '',
                                        'large-desktop': ''
                                    }
                                }
                            )}
                        )}
                    );
                }
            }
            );
        } else {
            this.log( 'digidesk Media Library not found, hiding media action...', 'warn' );

            // If not available, hide action button
            $( '.dd-veditor-media-action', this.$container ).hide();
        }

    };

    initializeNestedGrid( $nestedGrid, $widget )
    {
        this.log( 'Initializing Nested Grid' );
        this.log( $nestedGrid );
        this.log( this.options );

        var node             = $widget.data( '_gridstack_node' );
        var nestedCellHeight = Math.floor( ( ( this.options.colHeight * node.height ) - 85 ) / node.height );

        // Set grid min height
        //$nestedGrid.css( 'min-height', nestedCellHeight );

        // Initialize gridstack plugin
        GridStack.init(
            {
                verticalMargin: 10,
                cellHeight: nestedCellHeight,
                column: this.options.gridSize,
                //height:          1,
                acceptWidgets: false,
                resizable: {
                    autoHide: true,
                    handles: 'e'
                },
                minRow: 1
            },
            $nestedGrid
        );

        this.nestedgridstack = null;
    };

    initializePlugins()
    {
        this.log( 'Initialize 3rd Party plugins' );

        var self = this;

        // digidesk Media Library
        if ( typeof this.MediaLibrary !== 'undefined' )
        {
            $( '.dd-media-action', this.$modal ).on( 'click', function ()
                {
                    var $target = $( $( this ).data( 'target' ) );

                    self.MediaLibrary.open( function ( id, file )
                        {
                            $target.val( file ).trigger( 'change' );
                        }
                    );
                }
            );

            $( '.dd-widget-image-add-item', this.$modal ).on( 'click', function ()
                {
                    var $target = $( $( this ).data( 'target' ) );

                    self.MediaLibrary.open( /image\/.*/i, ( $target.data( 'multi' ) == 1 ), function ( files )
                        {
                            if ( $target.data( 'multi' ) != 1 )
                            {
                                files = [
                                    {
                                        file: arguments[ 1 ]
                                    }
                                ];
                            }

                            if ( files.length )
                            {
                                $.each( files, function ( i, item )
                                    {
                                        if ( !self.addInputImage( item.file, $target ) )
                                        {
                                            return false;
                                        }
                                    }
                                );
                            }
                        }
                    );
                }
            );

            $( '.dd-widget-image-delete-item', this.$modal ).on( 'click', function ()
                {
                    self.removeInputImage( $( this ).closest( '.dd-widget-item-col' ), $( $( this ).data( 'target' ) ) );
                }
            );
        }
        else
        {
            this.log( 'digidesk Media Library not found, disable media actions...', 'warn' );

            $( '.dd-media-action', this.$modal ).attr( 'disabled', 'disabled' ).addClass( 'disabled' );
        }

        // Summernote WYSIWYG Editor
        if ( typeof $().summernote === 'function' )
        {
            this.log( 'Setting summernote editor' );

            $( '.dd-editor', this.$modal ).each( function ()
                {
                    const wysiwyg = window.wysiwygUrl;
                    if (wysiwyg) {
                        (async () => {
                            try {
                                const ddoesummernote = await import(wysiwyg);
                                ddoesummernote.initializeSummernote($(this), {
                                    dialogsInBody: true,
                                    lang: window.adminLang == 'de' ? 'de-DE' : 'en-US',
                                    defaultProtocol: window.shopIsSSL == '1' ? 'https://' : 'http://'
                                });
                            } catch (error) {
                                console.error("Failed to load WYSIWYG module:", error);
                            }
                        })();
                    } else {
                        console.error("WYSIWYG not found");
                    }
                }
            );

            // Summernote enter key workaround for dialog windows
            $( '.dd-widget-form', this.$modal ).on( 'keypress', '.note-image-dialog input, .note-link-dialog input', function ( e )
                {
                    if ( e.keyCode === 13 )
                    {
                        e.preventDefault();
                        //e.stopPropagation();
                    }
                }
            );
        }

        // vanilla Color Picker
        if (typeof Picker !== 'undefined') {
            document.querySelectorAll('.vanilla-picker .vanilla-picker-input').forEach((element) => {
                element.addEventListener('click', openColorPicker);
                element.addEventListener('input', updateColorInputHandler);
            });

            function openColorPicker(event) {
                let inputElement = event.target;
                let swatchBlock = inputElement.parentElement.querySelector('.vanilla-picker-swatch');

                if(swatchBlock){
                    if (!swatchBlock.picker) {
                        let updateSwatchAndInputColor = (color) => {
                            swatchBlock.style.backgroundColor = color.hex;
                            inputElement.value = color.hex;
                        };

                        let picker = new Picker({
                            parent: swatchBlock,
                            popup: 'bottom',
                            cancelButton: true,
                            defaultColor: '#ffff',
                            color: inputElement.value,
                            onDone: updateSwatchAndInputColor
                        });

                        swatchBlock.picker = picker;
                    } else {
                        swatchBlock.picker.setColor(inputElement.value);
                    }

                    swatchBlock.picker.show();
                }
            }

            function updateColorInputHandler(event) {
                let inputElement = event.target;
                let swatchBlock = inputElement.parentElement.querySelector('.vanilla-picker-swatch');

                if (swatchBlock) {
                    try {
                        swatchBlock.style.backgroundColor = inputElement.value;
                        swatchBlock.picker.setColor(inputElement.value);
                    } catch (e) {}
                }
            }
        }

        // Selectize Selectbox Livesearch
        if ( typeof $().selectize === 'function' )
        {
            this.log( 'Setting selectize picker/boxes' );

            var escapeIcon = function ( text, escape )
            {
                var icon = '';
                var rexp = text.match( /(<i[^>]*class\=('|")fa[^"']*('|")[^>]*>[^<]*<\/i>)(.*)/ );

                if ( rexp && rexp.length === 5 )
                {
                    icon = rexp[ 1 ];
                    text = rexp[ 4 ];
                }

                return icon + escape( text );
            };

            $( '.dd-picker' ).each( function ()
                {
                    $( this ).selectize(
                        {
                            searchField: "label",
                            labelField: "label",
                            render: {
                                option: function ( data, escape )
                                {
                                    return '<div class="option">' + escapeIcon( data[ this.settings.labelField ], escape ) + '</div>';
                                },
                                item: function ( data, escape )
                                {
                                    return '<div class="item">' + escapeIcon( data[ this.settings.labelField ], escape ) + '</div>';
                                }
                            }
                        }
                    );
                }
            );
        }

        // Hint tooltips
        if ( $( '[data-toggle="tooltip"]', this.$modal ).length )
        {
            this.log( 'Setting hint tooltips' );

            $( '[data-toggle="tooltip"]', this.$modal ).tooltip();
        }

        // Area select plugin
        if ( typeof $().areaselect === 'function' )
        {
            this.log( 'Setting areaselect plugin' );

            $( '.dd-area-select' ).areaselect();
        }

        // Fix for multiple Bootstrap Modals
        $( document ).on( 'hidden.bs.modal', function ()
            {
                if ( $( '.modal:visible' ).length )
                {
                    $( 'body' ).addClass( 'modal-open' );
                }
            }
        );
    };

    setWidgetSelector()
    {
        this.log( 'Prepare Widget selector' );

        var self = this;

        $( '.dd-widget-select-box', self.$modal ).on( 'mouseenter', function ()
            {
                $( this ).css(
                    {
                        'background-color': $( this ).data( 'color' ),
                        'border-color': $( this ).data( 'color' ),
                        'color': '#fff'
                    }
                );
            }
        ).on( 'mouseleave', function ()
            {
                $( this ).css(
                    {
                        'background-color': '#f7f7f7',
                        'border-color': '#ccc',
                        'color': '#333'
                    }
                );
            }
        ).on( 'click', function ( e )
            {
                $( '.dd-widget-form-select', self.$modal ).hide();
                $( '.dd-widget-form-fields', self.$modal ).show();

                $( '.dd-widget-type-select' )[ 0 ].selectize.setValue( $( this ).data( 'widget' ) );

                if ( $( '.dd-tab-form', self.$modal ).length )
                {
                    $( '.dd-tab-form .nav-tabs li:visible > a', self.$modal ).first().tab( 'show' );
                }

                e.preventDefault();
            }
        );
    };


    // Internal Widget Methods
    // -----------------------

    add( type, params, position, callback )
    {
        this.log( 'Adding Widget "' + type + '"' );

        if ( this.nestedgridstack && type === 'column' )
        {
            this.ddh.alert( this.ddh.translate( 'DD_VISUAL_EDITOR_NESTED_COLUMN_WARNING' ) );

            typeof callback === 'function' && callback.call( this );

            return;
        }

        var self = this;

        if ( typeof position === 'function' )
        {
            callback = position;
            position = {};
        }

        if ( typeof params === 'undefined' || !params )
        {
            params = {};
        }

        position = $.extend( {}, VisualEditor.WIDGET_DEFAULTS, { size_x: self.options.defaultWidgetSize }, typeof position === 'object' && position );

        var autoPosition = false;

        if ( position.col && position.row )
        {
            position.col -= 1;
            position.row -= 1;
        }
        else
        {
            autoPosition = ( position.col == null || position.row == null );

            if ( autoPosition )
            {
                position.col = 0;
                position.row = 0;
            }
        }

        this.log( params );
        this.log( position );

        var wClass   = 'dd-veditor-widget';
        var wContent = '<div class="dd-widget-' + ( type === 'column' ? 'nested-' : '' ) + 'data">';

        if( type === 'column' )
        {
            wContent += '<a href="javascript:void(null)" class="dd-widget-action-movetarget" title="' + this.ddh.translate( 'DD_VISUAL_EDITOR_WIDGET_MOVETARGET' ) + '"><i class="fa fa-paste"></i></a>';
        }

        if ( this.shortcodes[ type ] )
        {
            if ( type === 'column' )
            {
                if ( autoPosition )
                {
                    position.size_x = this.options.gridSize;
                }

                wClass += ' dd-veditor-column dd-widget-type-column';
                wContent += '<div class="grid-stack grid-stack-' + this.options.gridSize + ' nested-grid"></div>';

            }
            else
            {
                wClass += ' dd-widget-type-' + type;

                var content = params[ this.shortcodes[ type ].previewParam ];

                var previewText = $.parseHTML(content, false);
                previewText = $(previewText).text();

                if ( previewText.length > 200 )
                {
                    previewText = previewText.substr( 0, 197 ) + '...';
                }

                var _tmp       = document.createElement("DIV");
                _tmp.textContent = previewText;
                var preview = _tmp.innerHTML;

                var icon = params.icon || this.shortcodes[ type ].icon;

                wContent += '<span class="dd-widget-icon"><i class="fa-solid ' + icon + '"></i></span>';
                wContent += '<span class="dd-widget-name">' + this.shortcodes[ type ].name + '</span>';
                wContent += '<span class="dd-widget-preview">' + preview + '</span>';
            }

        }

        wContent += '</div>';

        wContent += '<div class="dd-widget-actions">' +
            ( type === 'column' ? '<a href="javascript:void(null)" class="dd-widget-action-new-nested" title="' + this.ddh.translate( 'DD_VISUAL_EDITOR_ADD_WIDGET' ) + '"><i class="fa fa-plus"></i></a>' : '' ) +
            '  <a href="javascript:void(null)" class="dd-widget-action-edit" title="' + this.ddh.translate( 'DD_VISUAL_EDITOR_WIDGET_EDIT' ) + '"><i class="fa fa-edit"></i></a>' +
            ( type === 'column' ? '' : '  <a href="javascript:void(null)" class="dd-widget-action-duplicate" title="' + this.ddh.translate( 'DD_VISUAL_EDITOR_WIDGET_DUPLICATE' ) + '"><i class="fa fa-copy"></i></a>' ) +
            ( type === 'column' ? '' : '  <a href="javascript:void(null)" class="dd-widget-action-move" title="' + this.ddh.translate( 'DD_VISUAL_EDITOR_WIDGET_MOVE' ) + '"><i class="fa fa-cut"></i></a>' ) +
            '  <a href="javascript:void(null)" class="dd-widget-action-delete" title="' + this.ddh.translate( 'DD_VISUAL_EDITOR_WIDGET_DELETE' ) + '"><i class="fa fa-trash"></i></a>' +
            '</div>';

        var $widget = $( '<div class="grid-stack-item ' + wClass + '" data-widget="' + type + '"><div class="grid-stack-item-content dd-widget-inner">' + wContent + '</div></div>' );
        $widget.data( 'widget-params', params );

        if ( this.nestedgridstack )
        {
            var _gridstack = this.nestedgridstack;
        }
        else
        {
            var _gridstack = this.gridstack;
        }

        _gridstack.addWidget( $widget, Math.floor( position.col ), Math.floor( position.row ), Math.floor( position.size_x ), Math.floor( position.size_y ), autoPosition );

        self.setGridInfo( $widget, params );

        if ( type === 'column' )
        {
            this.initializeNestedGrid( $( '.nested-grid', $widget ), $widget );

            if ( typeof position.children === 'object' && position.children.length )
            {
                self.nestedgridstack = $( '.nested-grid', $widget ).get( 0 ).gridstack;

                $.each( position.children, function ( k, item )
                    {
                        self.add( item.widget, item.widget_params, item );
                    }
                );

                self.nestedgridstack = null;
            }
        }

        typeof callback === 'function' && callback.call( this, $widget, type, params );
    };

    replace( $widget, type, params, position, callback )
    {
        if ( typeof $widget !== 'object' || !$widget.length )
        {
            return;
        }

        this.log( 'Replacing Widget "' + type + '"' );
        this.log( $widget );

        // If is column, only update params
        if ( $widget.hasClass( 'dd-veditor-column' ) )
        {
            $widget.data( 'widget-params', params );

            this.setGridInfo( $widget, params );
        }
        else
        {
            var node = $widget.data( '_gridstack_node' );

            position = $.extend(
                {
                    col: ( node.x + 1 ),
                    row: ( node.y + 1 ),
                    size_x: node.width,
                    size_y: node.height
                },
                ( typeof position === 'object' && position )
            );

            this.remove( $widget );
            this.add( type, params, position, callback );
        }

    };

    remove( $widget, callback )
    {
        this.log( 'Removing Widget' );
        this.log( $widget );

        var _gridstack;

        if ( this.nestedgridstack )
        {
            _gridstack = this.nestedgridstack;
        }
        else
        {
            _gridstack = this.gridstack;
        }

        _gridstack.removeWidget( $widget );

        typeof callback === 'function' && callback.call( this );
    };

    serialize( $grid )
    {
        this.log( 'Serializing Widgets' );

        if ( typeof $grid === 'undefined' )
        {
            $grid = this.$grid;
        }

        var data = [];
        var self = this;

        $grid.children( '.grid-stack-item:visible' ).each( function ()
            {
                var node     = $( this ).data( '_gridstack_node' ),
                    type     = $( this ).data( 'widget' ),
                    params   = $( this ).data( 'widget-params' ),
                    children = [];

                if ( type === 'column' )
                {
                    children = self.serialize( $( '.nested-grid', this ) );
                }

                data.push(
                    {
                        row: ( node.y + 1 ),
                        col: ( node.x + 1 ),
                        size_x: node.width,
                        size_y: node.height,
                        widget: type,
                        widget_params: params,
                        children: children
                    }
                );
            }
        );

        data.sort( function ( a, b )
            {
                var asize = ( a.row * 10 ) + a.col;
                var bsize = ( b.row * 10 ) + b.col;

                if ( asize < bsize )
                {
                    return -1;
                }

                if ( asize > bsize )
                {
                    return 1;
                }

                return 0;
            }
        );

        return data;
    };

    clear()
    {
        this.log( 'Clearing all Widgets' );

        this.gridstack.removeAll();
    };

    setGridInfo( $widget, params )
    {
        if ( $widget.length )
        {
            this.log( 'Set Grid info' );

            if ( $( '.dd-widget-col-css', $widget ).length )
            {
                $( '.dd-widget-col-css', $widget ).remove();
            }

            var infoContent = '<div class="dd-widget-col-css">' +
                '  <ul class="list-inline">';

            var deviceIcons = {
                'small-mobile': 'fa fa-mobile-retro',
                'mobile': 'fa fa-mobile',
                'tablet': 'fa fa-tablet',
                'laptop': 'fa fa-laptop',
                'desktop': 'fa fa-desktop',
                'large-desktop': 'fa fa-tv'
            };

            var colStatusItems = {
                'small-mobile': '',
                'mobile': '',
                'tablet': '',
                'laptop': '',
                'desktop': '',
                'large-desktop': ''
            };

            if ( params.width )
            {
                var width = typeof params.width === 'string' ? JSON.parse( params.width ) : params.width;

                Object.keys( width ).forEach( function ( device )
                    {
                        if ( width[ device ] )
                        {
                            colStatusItems[ device ] = width[ device ];
                        }
                    }
                );
            }

            if ( params.offset )
            {
                var offset = typeof params.offset === 'string' ? JSON.parse( params.offset ) : params.offset;

                Object.keys( offset ).forEach( function ( device )
                    {
                        if ( offset[ device ] && offset[ device ] !== '0')
                        {
                            colStatusItems[ device ] = colStatusItems[ device ] + ' (Offset ' + offset[ device ] + ')';
                        }
                    }
                );
            }

            if ( params.hide )
            {
                var hide = typeof params.hide === 'string' ? JSON.parse( params.hide ) : params.hide;

                Object.keys( hide ).forEach( function ( device )
                    {
                        if ( hide[ device ] )
                        {
                            colStatusItems[ device ] = '<span class="text-danger"><i class="fa fa-ban"></i></span>';
                        }
                    }
                );
            }

            $.each( colStatusItems, function ( device )
                {
                    if ( colStatusItems[ device ] )
                    {
                        infoContent += '<li><i class="' + deviceIcons[device] + '"></i> ' + this + '</li>';
                    }
                }
            );

            infoContent += '</ul></div>';

            $( '.dd-widget-inner', $widget ).append( infoContent );
        }
    };

    addInputImage( imageFileInfo, $target )
    {
        var aImageFileInfo = imageFileInfo.split(';');
        var file = aImageFileInfo[0];
        var url = aImageFileInfo[1];

        if (file || url) {
            var $addItem = $('.dd-widget-image-add-item', $target);
            var $newItem = $('.dd-widget-image-item-helper', $target).clone(true).removeClass('dd-widget-image-item-helper');
            var $newCol = $('<div class="dd-widget-item-col col-sm-2" />').append($newItem);

            $('img', $newItem).attr('src', this.options.resourceLink + '/' + file);
            $('.dd-widget-image-item', $newItem).data('file', file);
            var imageUrlInput = $('.dd-widget-image-item', $newItem).next('.dd-widget-image-text');
            if (imageUrlInput.length) {
                imageUrlInput.val(url);
            }

            $addItem.parent().before($newCol);
        }

        if ( $target.data( 'max-length' ) && $( '.dd-widget-item-col', $target ).length >= $target.data( 'max-length' ) )
        {
            $addItem.hide();
            return false;
        }

        return true;
    };

    removeInputImage( $image, $target )
    {
        var $addItem = $( '.dd-widget-image-add-item', $target );

        $image.remove();

        if ( !$target.data( 'max-length' ) || $( '.dd-widget-item-col', $target ).length < $target.data( 'max-length' ) )
        {
            $addItem.show();
        }

    };

    clearInputImages( $target )
    {
        if ( !$target || !$target.length )
        {
            $target = this.$modal;
        }

        $( '.dd-widget-item-col', $target ).remove();
        $( '.dd-widget-image-add-item', $target ).show();
    };

    serializeInputImages( $target )
    {
        var data = [];

        var delimiter = ';';
        if ( $target.data( 'multi' ) === 1 )
        {
            $( '.dd-widget-item-col', $target ).each( function ()
                {
                    var imageInfo = $('.dd-widget-image-item', this).data('file');
                    if ( $('.dd-widget-image-item', this).next('.dd-widget-image-text').length )
                    {
                        imageInfo += delimiter + $('.dd-widget-image-item', this).next('.dd-widget-image-text').val();
                    }
                    data.push( imageInfo );
                }
            );
        }
        else
        {
            var widgetImageItem = $('.dd-widget-item-col .dd-widget-image-item', $target);
            data = widgetImageItem.first().data( 'file' );
            if ( widgetImageItem.next('.dd-widget-image-text').length )
            {
                data += delimiter + widgetImageItem.next('.dd-widget-image-text').val();
            }
        }

        return data;
    };

    addMoveTargetWidget( callback )
    {
        this.log( 'Adding target Widget' );

        var self = this;

        var currentRow = $( '.dd-veditor-grid' ).data( 'gs-current-row' );
        var position = {
            col: 0,
            row: currentRow + 1,
            size_x: this.options.gridSize
        };

        position = $.extend( {}, VisualEditor.WIDGET_DEFAULTS, { size_x: self.options.defaultWidgetSize }, typeof position === 'object' && position );

        var autoPosition = false;

        if ( !position.col || !position.row )
        {
            autoPosition = ( position.col == null || position.row == null );

            if ( autoPosition )
            {
                position.col = 0;
                position.row = 0;
            }
        }

        this.log( position );

        var $widget = $( '<div class="grid-stack-item move-target-widget"><a href="javascript:void(null)" class="grid-stack-item-content dd-widget-inner" title="' + self.ddh.translate( 'DD_VISUAL_EDITOR_WIDGET_MOVETARGET' ) + '"><i class="fa fa-paste"></i></a></div>' );

        var _gridstack = this.gridstack;

        _gridstack.addWidget( $widget, Math.floor( position.col ), Math.floor( position.row ), Math.floor( position.size_x ), Math.floor( position.size_y ), autoPosition );

        typeof callback === 'function' && callback.call( this, $widget );
    }

    removeMoveTargetWidget( callback )
    {
        this.log( 'Removing target Widget' );

        var $widget = $( '.move-target-widget' );
        this.log( $widget );

        var _gridstack = this.gridstack;

        _gridstack.removeWidget( $widget );

        typeof callback === 'function' && callback.call( this );
    };

    move( type, params, position )
    {
        this.add( type, params, position, function ()
            {
                var $nestedGrid = this.widgetToMove.closest( '.nested-grid' );

                if ( $nestedGrid.length )
                {
                  this.nestedgridstack = $nestedGrid.get( 0 ).gridstack;
                }
                else
                {
                  this.nestedgridstack = null;
                }

                this.remove( this.widgetToMove, function ()
                    {
                       this.nestedgridstack = null;
                       this.widgetToMove    = null;
                       $( '.dd-veditor-grid' ).removeClass( 'move-mode' );
                       this.log( 'Moving mode off' );
                    }
                );
            }
        );
    }

    deactivateMoveMode()
    {
        var $widget = $( '.move-source' );

        if( $widget.length )
        {
            this.log( 'Moving mode off' );

            $widget.removeClass( 'move-source' );
            this.widgetToMove = null;

            $( '.dd-veditor-grid' ).removeClass( 'move-mode' );
            if( $( '.move-target-widget' ).length )
            {
                this.removeMoveTargetWidget();
            }
        }
    }


    // External Widget Methods
    // -----------------------

    newWidget( callback )
    {
        this.log( 'Triggering new Widget' );

        this.clearModal();
        this.modal( function ( type, params )
            {
                this.log( 'Saving new Widget' );

                this.add( type, params, callback );
            }
        );

        $( '.dd-widget-form-select', this.$modal ).show();
        $( '.dd-widget-form-fields', this.$modal ).hide();
    };

    editWidget( $widget, callback )
    {
        if ( typeof $widget !== 'object' || !$widget.length )
        {
            return;
        }

        this.log( 'Triggering edit Widget' );

        this.clearModal();
        this.fillModal( $widget.data( 'widget' ), $widget.data( 'widget-params' ) );

        this.modal( function ( type, params )
            {
                this.log( 'Saving edited Widget' );

                this.replace( $widget, type, params, callback );
            }
        );

        $( '.dd-widget-form-select', this.$modal ).hide();
        $( '.dd-widget-form-fields', this.$modal ).show();
    };

    duplicateWidget( $widget, callback )
    {
        if ( typeof $widget !== 'object' || !$widget.length )
        {
            return;
        }


        var type = $widget.data('widget');
        var params = $widget.data( 'widget-params' );

        this.log( 'Duplicating Widget "' + type + '"' );
        this.log( $widget );

        var node = $widget.data( '_gridstack_node' );

        var position = {
            size_x: node.width,
            size_y: node.height
        };

        this.add( type, params, position, callback );
    };


    // Modal Methods
    // -------------

    clearModal()
    {
        this.log( 'Clearing modal form' );

        this.clearInputImages();

        $( 'input, textarea, select', this.$modal ).not( '.dd-widget-type-select' ).each( function ()
            {
                if ( $( this ).data( 'editable' ) === false )
                {
                    return;
                }

                if ( $( this ).is( 'input' ) )
                {
                    switch ( $( this ).attr( 'type' ) )
                    {
                        case 'checkbox':
                        case 'radio':
                            $( this ).prop( 'checked', false );
                            break;
                        default:
                            $( this ).val( '' );

                            if ( $( this ).data( 'default-value' ) )
                            {
                                $( this ).val( $( this ).data( 'default-value' ) );
                            }

                            if ( $( this ).data( 'random-value' ) )
                            {
                                $( this ).val( Math.floor( (1 + Math.random()) * 0x100000000 ) );
                            }

                            break;
                    }

                    if (this.classList.contains('dd-color-picker') && typeof Picker !== 'undefined') {
                        let swatchElement = this.parentElement.querySelector('.vanilla-picker-swatch');
                        swatchElement.style.backgroundColor = this.value;
                    }

                    if ( this.selectize )
                    {
                        this.selectize.setValue( '' );

                        if ( $( this ).data( 'default-value' ) )
                        {
                            this.selectize.setValue( $( this ).data( 'default-value' ) );
                        }
                    }

                }
                else
                {
                    $( this ).val( '' );

                    if ( $( this ).data( 'default-value' ) )
                    {
                        $( this ).val( $( this ).data( 'default-value' ) );
                    }

                    if ( $( this ).data( 'random-value' ) )
                    {
                        $( this ).val( Math.floor( (1 + Math.random()) * 0x100000000 ) );
                    }

                    if ( this.selectize )
                    {
                        this.selectize.setValue( '' );

                        if ( $( this ).data( 'default-value' ) )
                        {
                            this.selectize.setValue( $( this ).data( 'default-value' ) );
                        }
                    }

                    if ( $( this ).hasClass( 'dd-editor' ) && typeof $().summernote === 'function' )
                    {
                        $( this ).summernote( 'code', '' );

                        if ( $( this ).data( 'default-value' ) )
                        {
                            $( this ).summernote( 'code', $( this ).data( 'default-value' ) );
                        }

                        if ( $( this ).summernote( 'codeview.isActivated' ) )
                        {
                            $( this ).summernote( 'codeview.deactivate' );
                        }
                    }
                }
            }
        );
    };

    fillModal( type, data )
    {
        var self = this;

        this.log( 'Filling modal form' );
        this.log( type );
        this.log( data );

        // Set widget type
        $( '.dd-widget-type-select', this.$modal )[ 0 ].selectize.setValue( type );

        // Fill widget data
        $.each( data, function ( key, value )
            {
                if ( key === 'class' )
                {
                    var _selectize   = $( '.dd-widget-class', self.$modal )[ 0 ].selectize;
                    var _val_options = value.split( ' ' );

                    for ( var i in _val_options )
                    {
                        _selectize.addOption(
                            {
                                label: _val_options[ i ],
                                value: _val_options[ i ]
                            }
                        );
                    }

                    _selectize.refreshOptions( false );
                    _selectize.setValue( _val_options );

                    return;
                }

                if ( value && ['offset', 'width', 'hide'].includes( key ) ) {
                    if ( typeof value === 'string' )
                    {
                        value = JSON.parse(value);
                    }

                    switch ( key )
                    {
                        case 'offset':
                            Object.keys( value ).forEach( function( device )
                                {
                                    var _input = $( '*[name="col_offset[' + device + ']"]', self.$modal );

                                    if( _input.length && value[ device ] )
                                    {
                                        _input[ 0 ].selectize.setValue( value[ device ] === '0' ? 'none' : value[ device ] );
                                    }
                                }
                            );

                            break;

                        case 'width':
                            Object.keys( value ).forEach( function( device )
                                {
                                    var _input = $( '*[name="col_size[' + device + ']"]', self.$modal );

                                    if( _input.length && value[ device ] )
                                    {
                                        _input[ 0 ].selectize.setValue( value[ device ] );
                                    }
                                }
                            );

                            break;

                        case 'hide':
                            Object.keys( value ).forEach( function( device )
                                {
                                    var _input = $( '*[name="hide_device[' + device + ']"]', self.$modal );

                                    if( _input.length && value[ device ] )
                                    {
                                        _input.prop( 'checked', true );
                                    }
                                }
                            );

                            break;
                    }
                }

                var $elm = $( '*[name="' + type + '[' + key + ']' + ( typeof value === 'object' ? '[]' : '' ) + '"]', self.$modal ).last();

                if ( !$elm.length )
                {
                    var $imageList = $( '#elm_widget_images_' + type + '_' + key );

                    if ( $imageList.length )
                    {
                        if ( typeof value === 'string' )
                        {
                            value = [ value ];
                        }

                        $.each(value, function (i, imageFileInfo) {
                                self.addInputImage(imageFileInfo, $imageList);
                            }
                        );
                    }

                    return;
                }

                /*if( $elm.data( 'editable' ) === false )
                 {
                 return;
                 }*/

                if ( $elm.attr( 'type' ) === 'checkbox' )
                {
                    if ( value )
                    {
                        $elm.prop( 'checked', true );
                    }
                }
                else
                {
                    $elm.val( value );
                }

                if ( $elm.hasClass( 'dd-editor' ) && typeof $().summernote === 'function' )
                {
                    var editorContext = $elm.data( 'summernote' );

                    $elm.summernote( 'code', filterContent(value) );

                    editorContext.invoke( 'codeview.activate' );
                    editorContext.invoke( 'codeview.deactivate' );
                }

                if ( $elm.hasClass( 'dd-color-picker' ) && typeof Picker !== 'undefined')
                {
                    let swatchElement = $elm[0].parentElement.querySelector('.vanilla-picker-swatch');
                    swatchElement.style.backgroundColor = value;
                }

                if ( $elm[ 0 ].selectize )
                {
                    if ( $elm.hasClass( 'dd-data-picker' ) )
                    {
                        $elm[ 0 ].selectize.load( function ( callback )
                            {
                                $.ajax( {
                                    url: self.options.actionLink + '&fnc=doShortCodeAction&action=' + $elm.data( 'action' ) + '&shortcode=' + $elm.data( 'shortcode' ) + '&value=' + value,
                                    type: 'GET',
                                    error: function ()
                                    {
                                        callback();
                                    },
                                    success: function ( res )
                                    {
                                        callback( res );
                                        $elm[ 0 ].selectize.setValue( value );
                                    }
                                } );
                            }
                        );
                    }
                    else
                    {
                        $elm[ 0 ].selectize.setValue( value );
                    }
                }

            }
        );

        function filterContent(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString('<div>' + html + '</div>', 'text/html');

            const list = doc.getElementsByTagName('script');
            for (var i = list.length - 1; i >= 0; --i) {
                const node = list[i];
                const parent = node.parentNode;
                while (node.hasChildNodes()) {
                    parent.insertBefore(node.lastChild, node.nextSibling);
                }
                parent.removeChild(node);
            }

            return doc.querySelector('div').innerHTML;
        }
    };

    modal( options, callback )
    {
        var self = this;

        this.log( 'Showing modal' );

        if ( typeof options === 'function' )
        {
            callback = options;
            options  = {};
        }

        options = $.extend(
            {
                backdrop: false,
                keyboard: false,
                show: true
            },
            ( typeof options === 'object' && options )
        );

        this.$modal.one( 'show.bs.modal', function ()
            {
                self.log( 'Modal shown' );

                // Save widget form
                $( '.dd-widget-form', self.$modal ).one( 'submit', function ( e )
                    {
                        e.preventDefault();

                        self.log( 'Triggering form submit' );

                        var params  = {};
                        var type    = $( '#elm_widget_type', this ).val();
                        var css     = $( '#elm_widget_class', this ).val();
                        var offset = {
                            'small-mobile': 0,
                            'mobile': '',
                            'laptop': '',
                            'desktop': '',
                            'large-desktop': ''
                        };
                        var width = {
                            'small-mobile': 12,
                            'mobile': '',
                            'laptop': '',
                            'desktop': '',
                            'large-desktop': ''
                        };
                        var hide = {
                            'small-mobile': 0,
                            'mobile': 0,
                            'tablet': 0,
                            'laptop': 0,
                            'desktop': 0,
                            'large-desktop': 0
                        };

                        // Going through type params
                        $.each( $( this ).serializeArray(), function ()
                            {
                                var type_match = this.name.match( new RegExp( "^" + type + "\\\[([^\\\]]*)\\\](\\\[?)" ) );

                                if ( type_match !== null && type_match.length === 3 )
                                {
                                    if ( type_match[ 2 ].length )
                                    {
                                        if ( !params[ type_match[ 1 ] ] )
                                        {
                                            params[ type_match[ 1 ] ] = [];
                                        }

                                        params[ type_match[ 1 ] ].push( this.value );
                                    }
                                    else
                                    {
                                        var $elm = $( '*[name="' + this.name + '"]' );

                                        if( typeof $().summernote === 'function' && $elm.hasClass( 'dd-editor' ) )
                                        {
                                            var editorContext = $elm.data( 'summernote' );

                                            // deactivate codeview before getting value
                                            if( editorContext.invoke('codeview.isActivated') )
                                            {
                                                editorContext.invoke( 'codeview.deactivate' );
                                            }

                                            editorContext.invoke( 'codeview.activate' );

                                            params[ type_match[ 1 ] ] = $elm.summernote( 'code' );
                                        }
                                        else
                                        {
                                            params[ type_match[ 1 ] ] = this.value;
                                        }
                                    }
                                }

                                if ( this.value !== '' )
                                {
                                    var col_match = this.name.match( new RegExp( /^(col_offset|col_size|hide_device)\[([^\]]*)\]/ ) );

                                    if ( col_match !== null && col_match.length === 3 )
                                    {
                                        switch ( col_match[ 1 ] )
                                        {
                                            case 'col_size':
                                                width[ col_match[ 2 ] ] = this.value;

                                                break;

                                            case 'col_offset':
                                                offset[ col_match[ 2 ] ] = this.value === 'none' ? '0' : this.value;

                                                break;

                                            case 'hide_device':
                                                hide[ col_match[ 2 ] ] = this.value === 'none' ? '0' : this.value;

                                                break;
                                        }
                                    }
                                }

                            }
                        );

                        params[ 'class' ] = css;

                        params.offset = JSON.stringify( offset );
                        params.width = JSON.stringify( width );
                        params.hide = JSON.stringify( hide );

                        var $imageList = $( '.dd-widget-image-list[data-input-name^="' + type + '"]' );

                        if ( $imageList.length )
                        {
                            $imageList.each( function ()
                                {
                                    var type_match = $( this ).data( 'input-name' ).match( new RegExp( "^" + type + "\\\[([^\\\]]*)\\\](\\\[?)" ) );

                                    if( type_match )
                                    {
                                        params[ type_match[ 1 ] ] = self.serializeInputImages( $( this ) );
                                    }
                                }
                            );
                        }

                        // todo: check required fields

                        if ( typeof callback === 'function' )
                        {
                            // Exec the callback, stops on false
                            if ( callback.call( self, type, params ) === false )
                            {
                                return;
                            }
                        }
                        else
                        {
                            // todo: log
                        }

                        self.$modal.modal( 'hide' );
                    }
                );
            }
        ).one( 'shown.bs.modal', function ()
            {
                if ( $( '.dd-tab-form', self.$modal ).length )
                {
                    $( '.dd-tab-form .nav-tabs li:visible > a', self.$modal ).first().tab( 'show' );
                }
            }
        ).one( 'hidden.bs.modal', function ()
            {
                $( 'a[href="#tab_widget_main"]', self.$modal ).parent().show();
                $( '.dd-widget-form', self.$modal ).off( 'submit' );

                // Clear nested grid property
                self.nestedgridstack = null;
            }
        ).modal( options );
    };
}
